import ChatBot from "../bots/chatbot";
import { useState, useEffect } from "react";
import { selectPrompt, customizeBot, getBot } from "../../reducers/botReducer";
import { useSelector, useDispatch } from "react-redux";
import BotType from "./BotType";
import ChatBotDev from "../bots/chatbotdev";
import classNames from "classnames";
import {
  updateCurrentBotPrompt,
  removeCurrentBot,
} from "../../reducers/botReducer";
import { updateCurrentBotName } from "../../reducers/botReducer";
import { NotificationManager } from "react-notifications";
import { useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";

const BotPrompt = (props) => {
  const setStep = props.setStep;
  const setPrompt = props.setPrompt;
  const [templateType, setTemplateType] = useState(0);
  const { id } = useParams();
  const currentBotDetail = useSelector((state) => state.bot.currentBotDetail);
  const [option, setOption] = useState(0);
  const [type, setType] = useState(0);
  const navigate = useNavigate();

  const [botName, setBotName] = useState("");
  const [botDesc, setBotDesc] = useState("");

  const [template, setTemplate] = useState(
    `You are OrderBot, an automated service to collect orders for a pizza restaurant.
You first greet the customer, then collect the order,
and then ask if it's a pickup or delivery.
You wait to collect the entire order, then summarize it and check for a final
time if the customer wants to add anything else.
If it's a delivery, you ask for an address.
Finally, you collect the payment.\n
Make sure to clarify all options, extras, and sizes to uniquely
identify the item from the menu.\n
You respond in a short, very conversational, friendly style.
The menu includes
pepperoni pizza  12.95, 10.00, 7.00
cheese pizza   10.95, 9.25, 6.50
eggplant pizza   11.95, 9.75, 6.75
fries 4.50, 3.50
greek salad 7.25
Toppings:
extra cheese 2.00,
mushrooms 1.50
sausage 3.00
canadian bacon 3.50
AI sauce 1.50
peppers 1.00
Drinks:
coke 3.00, 2.00, 1.00
sprite 3.00, 2.00, 1.00
bottled water 5.00 `
  );

  const [edit, setEdit] = useState(0);

  const dispatch = useDispatch();

  const promptSelect = async (prompt) => {
    const payload = {
      prompt,
      botId: id,
    };
    dispatch(updateCurrentBotPrompt(payload));
    await dispatch(selectPrompt(payload));
  };

  const nextStep = async () => {
    let payload = {
      btype: templateType,
      prompt: template,
    };
    // await dispatch(updateCurrentBotPrompt(payload));

    if (botName == "") {
      NotificationManager.warning("Pleae Input BotName...", "", 2000);
      return;
    }
    if (botDesc == "") {
      NotificationManager.warning("Pleae Input Bot Description", "", 2000);
      return;
    }
    payload = {
      botId: id,
      btype: templateType,
      name: botName,
      desc: botDesc,
      prompt: template,
    };
    await dispatch(updateCurrentBotName(payload));
    await dispatch(customizeBot(payload));

    navigate(`/createBot/knowledge/${id}`);
  };

  const prevStep = async () => {
    await dispatch(removeCurrentBot());
    navigate(`/createBot/select`);
  };

  const getCurrentBot = async () => {
    dispatch(getBot({ botId: id }));
  };

  useEffect(() => {
    getCurrentBot();
  }, []);
  useEffect(() => {
    // if (currentBotDetail.prompt == "") promptSelect();
    // else {
    setTemplate(currentBotDetail.prompt);
    setBotName(currentBotDetail.name);
    setBotDesc(currentBotDetail.desc);
    setTemplateType(parseInt(currentBotDetail.bot_type));
    // }
  }, [currentBotDetail]);
  return (
    // <div className="text-left flex">
    <div className="w-[80%] my-[20px] mx-[20px]">
      <h1
        className="text-left mb-[10px]"
        style={{
          fontFamily: "Inter",
          fontSize: "24px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "normal",
          color: "var(--main-1-c-274-c, #1C274C)",
        }}
      >
        Customize your prompt template
      </h1>
      <h2
        style={{
          fontFamily: "Inter",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
          color: "var(--main-1-c-274-c, #1C274C)",
        }}
        className="mb-[30px]"
      >
        Prompt template defines the purpose of your application and ensures it
        responds within provided guardrails.
        <Link
          style={{ textDecorationLine: "underline", marginLeft: "5px" }}
          to={
            "https://medium.com/@getbind.co/how-to-build-complex-llm-applications-with-your-own-data-and-services-c9186e92d926"
          }
          target="_blank"
        >
          Learn More
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            style={{ display: "inline" }}
          >
            <g clip-path="url(#clip0_275_1044)">
              <path
                d="M12.75 13.4583H4.25C3.86042 13.4583 3.54167 13.1396 3.54167 12.75V4.25C3.54167 3.86042 3.86042 3.54167 4.25 3.54167H7.79167C8.18125 3.54167 8.5 3.22292 8.5 2.83333C8.5 2.44375 8.18125 2.125 7.79167 2.125H3.54167C2.75542 2.125 2.125 2.7625 2.125 3.54167V13.4583C2.125 14.2375 2.7625 14.875 3.54167 14.875H13.4583C14.2375 14.875 14.875 14.2375 14.875 13.4583V9.20833C14.875 8.81875 14.5562 8.5 14.1667 8.5C13.7771 8.5 13.4583 8.81875 13.4583 9.20833V12.75C13.4583 13.1396 13.1396 13.4583 12.75 13.4583ZM9.91667 2.83333C9.91667 3.22292 10.2354 3.54167 10.625 3.54167H12.4596L5.9925 10.0087C5.71625 10.285 5.71625 10.7312 5.9925 11.0075C6.26875 11.2837 6.715 11.2837 6.99125 11.0075L13.4583 4.54042V6.375C13.4583 6.76458 13.7771 7.08333 14.1667 7.08333C14.5562 7.08333 14.875 6.76458 14.875 6.375V2.83333C14.875 2.44375 14.5562 2.125 14.1667 2.125H10.625C10.2354 2.125 9.91667 2.44375 9.91667 2.83333Z"
                fill="#1C274C"
              />
            </g>
            <defs>
              <clipPath id="clip0_275_1044">
                <rect width="17" height="17" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Link>
      </h2>

      <h1
        className="text-left mb-[20px]"
        style={{
          fontFamily: "Inter",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "normal",
          color: "var(--main-1-c-274-c, #1C274C)",
        }}
      >
        Enter bot name and description
      </h1>

      <div className="flex w-full mb-[30px]">
        <input
          type="text"
          className="form-field mr-5 w-[350px] text-left"
          placeholder="Apple Support bot"
          value={botName}
          onChange={(e) => {
            setBotName(e.target.value);
            let payload = {
              botId: id,
              btype: templateType,
              name: e.target.value,
              desc: botDesc,
              prompt: template,
            };
            dispatch(updateCurrentBotName(payload));
          }}
        />
        <input
          className="form-field flex-1"
          type="text"
          placeholder="Short Bot description for internal and external use"
          value={botDesc}
          onChange={(e) => {
            setBotDesc(e.target.value);
            let payload = {
              botId: id,
              btype: templateType,
              name: botName,
              desc: e.target.value,
              prompt: template,
            };
            dispatch(updateCurrentBotName(payload));
          }}
        />
      </div>
      <h1
        className="text-left mb-[10px]"
        style={{
          fontFamily: "Inter",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "normal",
          color: "var(--main-1-c-274-c, #1C274C)",
        }}
      >
        Select a pre-filled template
      </h1>
      <h2
        style={{
          fontFamily: "Inter",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
          color: "var(--main-1-c-274-c, #1C274C)",
        }}
        className="mb-2"
      >
        Pre-filled templated tab in this sheet
      </h2>
      <div className="mb-4">
        {/* <BotType
          title="Create a custom LLM API"
          desc="Build an API with your knowledge base, and call it in your application"
          currentType={type}
          actualType={5}
          soon={1}
          setType={setType}
        /> */}
        <select
          className="bot-type-select"
          onChange={(e) => {
            setTemplateType(e.target.value);
            let prompt = "";
            if (e.target.value == 0) {
              prompt = `
              You are OrderBot, an automated service to collect orders for a pizza restaurant.
You first greet the customer, then collect the order,
and then ask if it's a pickup or delivery.
You wait to collect the entire order, then summarize it and check for a final
time if the customer wants to add anything else.
If it's a delivery, you ask for an address.
Finally, you collect the payment.

Make sure to clarify all options, extras, and sizes to uniquely
identify the item from the menu.

You respond in a short, very conversational, friendly style.
The menu includes
pepperoni pizza  12.95, 10.00, 7.00
cheese pizza   10.95, 9.25, 6.50
eggplant pizza   11.95, 9.75, 6.75
fries 4.50, 3.50
greek salad 7.25
Toppings:
extra cheese 2.00,
mushrooms 1.50
sausage 3.00
canadian bacon 3.50
AI sauce 1.50
peppers 1.00
Drinks:
coke 3.00, 2.00, 1.00
sprite 3.00, 2.00, 1.00
bottled water 5.00`;
            }
            if (e.target.value == 1) {
              prompt =
                "You are a Data Extractor bot. Your task is to extract entities from provided human inputs and respond in a json with details about the following entities all the person, company, email, phone number, topic, funding, executive names, financial details, location, key events mentioned in the text Wherever necessary, you will create an array object and keep the related information together. If you don't find any relevant data to extract, skip the field in the json. Make sure to enclose your entire response in ``";
            }
            if (e.target.value == 2)
              prompt = `You are an AI Assistant named Jarvis, you can provide answers to any questions. If you don't know the answer, please say "42"`;
            if (e.target.value == 3)
              prompt = `You are an API bot, your job is to use the the provided api documentation in triple backticks to explain how to best to interact with the apis for the users request.`;
            if (e.target.value == 4)
              prompt =
                "You are a Sales Assistant. Your job is to ask users about their sales needs and provide recommended leads which meet their target criteria. You will only use the data provided in triple backticks to provide an answer. You will recommend leads in a table format with the following fields: Company Name, Website, Location, Revenue, Company Size";
            promptSelect(prompt);
          }}
        >
          <option value={0} selected={templateType == 0}>
            Pizza Order Bot
          </option>
          <option value={1} selected={templateType == 1}>
            Data Extraction to JSON
          </option>
          <option value={2} selected={templateType == 2}>
            General Purpose
          </option>
          <option value={3} selected={templateType == 3}>
            API bot
          </option>
          <option value={4} selected={templateType == 4}>
            Sales Assistant
          </option>
        </select>
      </div>
      <h1
        className="text-left mb-[10px]"
        style={{
          fontFamily: "Inter",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "normal",
          color: "var(--main-1-c-274-c, #1C274C)",
        }}
      >
        Prompt template
      </h1>
      <h2
        style={{
          fontFamily: "Inter",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
          color: "var(--main-1-c-274-c, #1C274C)",
        }}
        className="mb-[30px]"
      >
        We auto-generated a template for you, please edit and test the
        responses.
      </h2>

      <div className="prompt-template-editor">
        <div className="prompt-template-editor-header flex justify-center items-center">
          <h1>Editor</h1>
          <div className="flex-1"></div>
          {edit == 0 ? (
            <button
              className="flex items-center justify-center edit-template-button"
              onClick={() => setEdit(1)}
            >
              Edit Template
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
              >
                <g clip-path="url(#clip0_275_1081)">
                  <path
                    d="M3.12598 11.7602V13.5756C3.12598 13.7428 3.25735 13.8741 3.42455 13.8741H5.23985C5.31748 13.8741 5.39511 13.8443 5.44885 13.7846L11.9696 7.26965L9.73034 5.03034L3.21555 11.5452C3.15583 11.605 3.12598 11.6766 3.12598 11.7602ZM13.7013 5.53791C13.9342 5.30502 13.9342 4.92882 13.7013 4.69593L12.304 3.2986C12.0711 3.06571 11.6949 3.06571 11.462 3.2986L10.3693 4.39138L12.6085 6.6307L13.7013 5.53791Z"
                    fill="#1C274C"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_275_1081">
                    <rect width="17" height="17" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          ) : (
            <div className="flex">
              <button
                className="flex items-center justify-center edit-template-button mr-1"
                onClick={() => {
                  setEdit(0);
                  promptSelect(template);
                }}
              >
                Save
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  className="ml-1"
                >
                  <g clip-path="url(#clip0_369_567)">
                    <path
                      d="M12.4596 2.54292C12.1904 2.27375 11.8292 2.125 11.4537 2.125H3.54167C2.75542 2.125 2.125 2.7625 2.125 3.54167V13.4583C2.125 14.2375 2.7625 14.875 3.54167 14.875H13.4583C14.2375 14.875 14.875 14.2375 14.875 13.4583V5.54625C14.875 5.17083 14.7262 4.80958 14.4571 4.5475L12.4596 2.54292ZM8.5 13.4583C7.32417 13.4583 6.375 12.5092 6.375 11.3333C6.375 10.1575 7.32417 9.20833 8.5 9.20833C9.67583 9.20833 10.625 10.1575 10.625 11.3333C10.625 12.5092 9.67583 13.4583 8.5 13.4583ZM9.20833 6.375H4.95833C4.17917 6.375 3.54167 5.7375 3.54167 4.95833C3.54167 4.17917 4.17917 3.54167 4.95833 3.54167H9.20833C9.9875 3.54167 10.625 4.17917 10.625 4.95833C10.625 5.7375 9.9875 6.375 9.20833 6.375Z"
                      fill="#1C274C"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_369_567">
                      <rect width="17" height="17" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button
                className="flex items-center justify-center edit-template-button"
                onClick={() => {
                  setEdit(0);
                  let prompt = `You are OrderBot, an automated service to collect orders for a pizza restaurant.
You first greet the customer, then collect the order,
and then ask if it's a pickup or delivery.
You wait to collect the entire order, then summarize it and check for a final
time if the customer wants to add anything else.
If it's a delivery, you ask for an address.
Finally, you collect the payment.\n
Make sure to clarify all options, extras, and sizes to uniquely
identify the item from the menu.\n
You respond in a short, very conversational, friendly style.
The menu includes
pepperoni pizza  12.95, 10.00, 7.00
cheese pizza   10.95, 9.25, 6.50
eggplant pizza   11.95, 9.75, 6.75
fries 4.50, 3.50
greek salad 7.25
Toppings:
extra cheese 2.00,
mushrooms 1.50
sausage 3.00
canadian bacon 3.50
AI sauce 1.50
peppers 1.00
Drinks:
coke 3.00, 2.00, 1.00
sprite 3.00, 2.00, 1.00
bottled water 5.00 `;
                  promptSelect(prompt);
                }}
              >
                Back to default
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="13"
                  viewBox="0 0 15 13"
                  fill="none"
                  className="ml-1"
                >
                  <path
                    d="M8.39254 0.12497C4.78713 0.0258031 1.83338 2.92289 1.83338 6.49997H0.565459C0.246709 6.49997 0.0908753 6.88247 0.317542 7.10205L2.29379 9.08539C2.43546 9.22705 2.65504 9.22705 2.79671 9.08539L4.77296 7.10205C4.99254 6.88247 4.83671 6.49997 4.51796 6.49997H3.25004C3.25004 3.73747 5.50254 1.50622 8.27921 1.54164C10.9142 1.57705 13.1313 3.79414 13.1667 6.42914C13.2021 9.19872 10.9709 11.4583 8.20837 11.4583C7.06796 11.4583 6.01254 11.0687 5.17671 10.41C4.89338 10.1904 4.49671 10.2116 4.24171 10.4666C3.94421 10.7641 3.96546 11.2671 4.29838 11.5221C5.37504 12.3721 6.72796 12.875 8.20837 12.875C11.7855 12.875 14.6825 9.92122 14.5834 6.3158C14.4913 2.99372 11.7146 0.217053 8.39254 0.12497ZM8.03129 3.66664C7.74088 3.66664 7.50004 3.90747 7.50004 4.19789V6.80455C7.50004 7.05247 7.63462 7.28622 7.84713 7.41372L10.0571 8.72414C10.3121 8.87289 10.638 8.78789 10.7867 8.53997C10.9355 8.28497 10.8505 7.95914 10.6025 7.81039L8.56254 6.59914V4.1908C8.56254 3.90747 8.32171 3.66664 8.03129 3.66664Z"
                    fill="#1C274C"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
        <textarea
          className={classNames("prompt-template-editor-body", {
            "pointer-events-none": edit == 0,
          })}
          rows={10}
          placeholder="Select a prompt template or write your own. Make sure to Save it before proceeding!"
          value={template}
          onChange={(e) => setTemplate(e.target.value)}
        ></textarea>
      </div>

      <div className="flex p-[24px]">
        <div className="flex-1 mr-[10px]">
          <h2
            style={{
              fontFamily: "Inter",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "normal",
              color: "var(--main-1-c-274-c, #1C274C)",
            }}
            className="mb-[8px] flex items-center"
          >
            Select Model
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              className="ml-[5px]"
            >
              <g clip-path="url(#clip0_1745_10756)">
                <path
                  d="M8.49996 1.41699C4.58996 1.41699 1.41663 4.59033 1.41663 8.50033C1.41663 12.4103 4.58996 15.5837 8.49996 15.5837C12.41 15.5837 15.5833 12.4103 15.5833 8.50033C15.5833 4.59033 12.41 1.41699 8.49996 1.41699ZM9.20829 13.4587H7.79163V12.042H9.20829V13.4587ZM10.6745 7.96908L10.037 8.62074C9.68288 8.98199 9.42788 9.30783 9.30038 9.81783C9.24371 10.0445 9.20829 10.2995 9.20829 10.6253H7.79163V10.2712C7.79163 9.94533 7.84829 9.63366 7.94746 9.34324C8.08913 8.93241 8.32288 8.56408 8.62038 8.26658L9.49871 7.37408C9.82454 7.06241 9.98038 6.59491 9.88829 6.09908C9.79621 5.58908 9.39954 5.15699 8.90371 5.01533C8.11746 4.79574 7.38788 5.24199 7.15413 5.91491C7.06913 6.17699 6.84954 6.37533 6.57329 6.37533H6.36079C5.94996 6.37533 5.66663 5.97866 5.77996 5.58199C6.08454 4.54074 6.96996 3.74741 8.06788 3.57741C9.14454 3.40741 10.1716 3.96699 10.8091 4.85241C11.645 6.00699 11.397 7.24658 10.6745 7.96908Z"
                  fill="#848A9E"
                />
              </g>
              <defs>
                <clipPath id="clip0_1745_10756">
                  <rect width="17" height="17" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </h2>
          <select
            className="bot-type-select w-full"
            // onChange={(e) => setTemplateType(e.target.value)}
          >
            <option value={0}>gpt-3.5-turbo-16k</option>
            {/* <option value={1}>Personal Assistants</option>
            <option value={2}>General Purpose GPT Chatbot</option>
            <option value={3}>Sales Agent Chatbot</option>
            <option value={4}>I don't know, I just need a bot</option> */}
          </select>
        </div>
        <div className="flex-1">
          <h2
            style={{
              fontFamily: "Inter",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "normal",
              color: "var(--main-1-c-274-c, #1C274C)",
            }}
            className="mb-[8px]"
          >
            Select Conversational memory
          </h2>
          <select
            className="bot-type-select w-full"
            // onChange={(e) => setTemplateType(e.target.value)}
          >
            <option value={0}>Conversational Buffer Memory</option>
            {/* <option value={1}>Personal Assistants</option>
            <option value={2}>General Purpose GPT Chatbot</option>
            <option value={3}>Sales Agent Chatbot</option>
            <option value={4}>I don't know, I just need a bot</option> */}
          </select>
        </div>
      </div>

      {/* <select
          className="border rounded-md p-3 m-6"
          onChange={(e) => setOption(e.target.value)}
        >
          <option value={0} disabled>
            Dropdown which allows you to pick an option.
          </option>
          <hr />
          <option value={1}>Bot for sales</option>
          <option value={2}>Bot for support</option>
        </select>
        <h1 className="text-3xl m-6">Prompt template</h1>
        <textarea
          className="w-full p-3 border rounded-md m-6"
          rows={10}
          placeholder={`Show the full langchain Prompt template for the bot. Bot developer should be able to edit the template in this box.

You are a helpful customer support assistant. Respond to questions in a friendly tone
Use the below data

"...""`}
          value={prompts[option]}
        ></textarea>
        <button
          className="px-10 py-2 rounded-md text-red-600 m-6 border border-red-600 transition hover:bg-red-600 hover:text-white"
          onClick={() => promptSelect()}
        >
          Select Prompt
        </button>
        <div>
          <button
            className="bg-black px-10 py-2 rounded-md text-white m-6"
            onClick={() => setStep(0)}
          >
            Prev Step
          </button>
          <button
            className="bg-black px-10 py-2 rounded-md text-white m-6"
            onClick={() => setStep(2)}
          >
            Next Step
          </button>
        </div>
      </div>
      <div className="w-[300px] m-5 text-left px-6 border rounded-md pb-2">
        <div className="mt-6 pt-10 mb-12">
          <h1 className="my-3">This is a Chatbot in test mode.</h1>
          <p className="my-3">
            Bot developer can test questions as soon as any updates are made to
            the prompt template. or a knowledgebase is added.
          </p>
          <p className="my-6">
            This panel is available in all screens (except the first screen)
          </p>
        </div>
        <ChatBot id={""} /> */}
      <div className="flex justify-end">
        <button className="prev-button" onClick={() => prevStep()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
          >
            <g clip-path="url(#clip0_696_2975)">
              <path
                d="M14.2888 6.4304C13.915 6.05665 13.3113 6.05665 12.9375 6.4304L8.53875 10.8291C8.165 11.2029 8.165 11.8066 8.53875 12.1804L12.9375 16.5791C13.3113 16.9529 13.915 16.9529 14.2888 16.5791C14.6625 16.2054 14.6625 15.6016 14.2888 15.2279L10.5704 11.5L14.2888 7.78165C14.6529 7.4079 14.6529 6.79456 14.2888 6.4304Z"
                fill="#1C274C"
              />
            </g>
            <defs>
              <clipPath id="clip0_696_2975">
                <rect width="23" height="23" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Previous step
        </button>
        <button className="next-button" onClick={() => nextStep()}>
          Next: Vector Index
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
          >
            <g clip-path="url(#clip0_696_2972)">
              <path
                d="M8.9221 6.43039C8.54835 6.80414 8.54835 7.40789 8.9221 7.78164L12.6404 11.5L8.9221 15.2183C8.54835 15.5921 8.54835 16.1958 8.9221 16.5696C9.29585 16.9433 9.8996 16.9433 10.2733 16.5696L14.6721 12.1708C15.0458 11.7971 15.0458 11.1933 14.6721 10.8196L10.2733 6.4208C9.90918 6.05664 9.29585 6.05664 8.9221 6.43039Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_696_2972">
                <rect width="23" height="23" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
    </div>
    // <ChatBotDev />
    // </div>
  );
};

export default BotPrompt;
